import { Link } from 'react-router-dom';
import { EmptyState } from '../components/Feedback';
import { PageHeader } from '../components/Page';

export function NotFoundPage(): JSX.Element {
  return (
    <>
      <PageHeader title="Page not found" />
      <EmptyState
        title="That page does not exist"
        description="The link may be stale, or the screen may need a role you do not hold."
        icon="?"
        action={
          <Link className="btn btn-primary" to="/">
            Back to the dashboard
          </Link>
        }
      />
    </>
  );
}
